import { render, staticRenderFns } from "./SetPopupDialog.vue?vue&type=template&id=5dd6b7fa&scoped=true"
import script from "./SetPopupDialog.vue?vue&type=script&lang=js"
export * from "./SetPopupDialog.vue?vue&type=script&lang=js"
import style0 from "./SetPopupDialog.vue?vue&type=style&index=0&id=5dd6b7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd6b7fa",
  null
  
)

export default component.exports